import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "suggestions-panel" }
const _hoisted_2 = {
  key: 0,
  class: "suggestions-list"
}
const _hoisted_3 = {
  key: 1,
  class: "no-suggestions"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "No suggestions available", -1)
const _hoisted_5 = [
  _hoisted_4
]


import SuggestionItem from "./SuggestionItem.vue";
import { useSuggestionHandlers } from "../../composables/useSuggestionHandlers";
import {
  AI_RESUME_COMMANDS,
  type AddWorkAchievementMetadata,
  type EditWorkAchievementMetadata,
  type ResumeSuggestion,
} from "../../../../server/src/models/dtos/ResumeSuggestionsOutput";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeSuggestionsPanel',
  props: {
    suggestions: {},
    resume: {}
  },
  emits: ["accept", "reject", "refresh", "highlight-text"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { handleAccept, handleReject, handleRefresh } = useSuggestionHandlers(emit);

function emitHighlightText(payload: { suggestion: ResumeSuggestion; highlight: boolean }) {
  emit("highlight-text", payload);
}

function updateSuggestionContent(payload: { suggestion: ResumeSuggestion; content: string }) {
  // Update the suggestion content
  payload.suggestion.change = payload.content;

  // If this is a summary suggestion, update the metadata
  if (
    payload.suggestion.command === AI_RESUME_COMMANDS.ADD_SUMMARY ||
    payload.suggestion.command === AI_RESUME_COMMANDS.EDIT_SUMMARY
  ) {
    if (!payload.suggestion.metadata) payload.suggestion.metadata = {};
    if (!payload.suggestion.metadata.summary) payload.suggestion.metadata.summary = {};
    payload.suggestion.metadata.summary.description = payload.content;
  } else if (
    payload.suggestion.command === AI_RESUME_COMMANDS.ADD_WORK_ACHIEVEMENT ||
    payload.suggestion.command === AI_RESUME_COMMANDS.EDIT_WORK_ACHIEVEMENT ||
    payload.suggestion.command === AI_RESUME_COMMANDS.ADD_PROJECT ||
    payload.suggestion.command === AI_RESUME_COMMANDS.EDIT_PROJECT
  ) {
    const metadata = { achievement: payload.content };
    payload.suggestion.metadata = metadata;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.suggestions.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (suggestion) => {
            return (_openBlock(), _createBlock(SuggestionItem, {
              key: suggestion.id,
              suggestion: suggestion,
              resume: _ctx.resume,
              onAccept: _unref(handleAccept),
              onReject: _unref(handleReject),
              onRefresh: _unref(handleRefresh),
              onHighlightText: emitHighlightText,
              "onUpdate:content": updateSuggestionContent
            }, null, 8, ["suggestion", "resume", "onAccept", "onReject", "onRefresh"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
  ]))
}
}

})